import React, { useState } from 'react';
import { Product } from '../data/mockData';
import { TransformedLayer } from '../utils/resourceUtils';

interface SaveDesignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (designName: string) => Promise<void>;
  isSaving: boolean;
}

const SaveDesignModal: React.FC<SaveDesignModalProps> = ({
  isOpen,
  onClose,
  onSave,
  isSaving
}) => {
  const [designName, setDesignName] = useState('');

  const handleClose = () => {
    setDesignName('');
    onClose();
  };

  const handleSave = async () => {
    if (!designName.trim()) {
      alert('Please fill in the design name');
      return;
    }
    
    await onSave(designName.trim());
    setDesignName('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[500]">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-xl font-bold mb-4">Save Design</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Design Name *
            </label>
            <input
              type="text"
              value={designName}
              onChange={(e) => setDesignName(e.target.value)}
              placeholder="Enter design name"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        
        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isSaving || !designName.trim()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? 'Saving...' : 'Save Design'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveDesignModal;
